import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'web-tab-controls',
    templateUrl: './tab-controls.component.html',
    styleUrls: ['./tab-controls.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BsDropdownModule, TranslatePipe, TooltipModule],
})
export class TabControlsComponent {
    @Input() public disableRemoveEvent: boolean;
    @Input() public selectActionTooltip: string;
    @Input() public disableRemoveEventTooltip: string;

    @Output() public deleteEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public selectEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public toggleMoreActionState: EventEmitter<boolean> = new EventEmitter<boolean>();

    public deleteAction(): void {
        this.deleteEvent.emit();
    }

    public selectAction(): void {
        this.selectEvent.emit();
    }

    public isShowDropDownMenu(state): void {
        this.toggleMoreActionState.emit(state);
    }
}
